var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33316 7.23335e-05C8.75983 7.23708e-05 9.1865 0.163406 9.5115 0.488407C10.1632 1.14007 10.1632 2.19341 9.5115 2.84507L4.00316 8.35341L9.30316 13.8417C9.94149 14.5051 9.92316 15.5601 9.26149 16.1984C8.59816 16.8367 7.54316 16.8184 6.90483 16.1584L0.468162 9.49174C-0.163505 8.83674 -0.155171 7.7984 0.488162 7.15507L7.15483 0.488407C7.47983 0.163406 7.9065 7.22962e-05 8.33316 7.23335e-05Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.73e747793370f2610bfc2aa8278c5e91.svg";
export { ForwardRef as ReactComponent };